import styled, { css } from "styled-components";
import { lighten } from "polished";
import { ValidationState } from "../../shared-style";

import { IStyleProps } from "./interfaces";

const CommonCss = css`
    font-size: 17px;
    padding: 9px 16px;
    box-sizing: border-box;
    font-weight: 300;
    cursor: pointer;
`;

export const SelectWrapper = styled.div`
    position: relative;
    outline: none;

    .Caret {
        position: absolute;
        top: 19px;
        right: 12px;
        pointer-events: none;

        svg {
            display: block;
            polygon {
                fill: ${p => p.theme.c.grey7};
            }
        }
    }
    &.Dark {
        background-color: transparent;
        border: none;
        font-weight: 600;
        padding-left: 4px;
        .Caret {
            svg polygon {
                fill: ${p => p.theme.c.dark};
            }
        }

        .Options {
            min-width: 70px;
        }
    }

    &.SelectDisabled {
        &,
        input::placeholder {
            color: ${p => p.theme.c.disabled};
        }
        cursor: default !important;

        .Caret {
            svg polygon {
                fill: ${p => p.theme.c.disabled};
            }
        }
    }

    &.SelectOpened,
    &:focus {
        .Select,
        input {
            border-color: ${p => p.theme.c.active};
            outline: 0;
        }

        .Caret {
            svg polygon {
                fill: ${p => p.theme.c.active};
            }
        }
    }

    &.SelectLight {
        ${p => p.theme.mode === "light" && css`
            .Select,
            input {
                background-color: ${p => p.theme.c.light};
                border-color: ${p => p.theme.c.active};
            }
        `}
    }
`;

export const StyledSelect = styled.div`
    background-color: ${p => p.theme.c.cardBackground};
    outline: none;
    width: 100%;
    appearance: none;
    border: ${p => p.theme.mode === "dark" ? p.theme.c.cardBackground : p.theme.c.disabled} 1px solid;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    ${CommonCss}
    padding-right: 27px;
    border-radius: 8px;
    line-height: 22px;
    ${ValidationState}
    &::placeholder {
        color: ${p => p.theme.mode === "dark" ? p.theme.c.whiteOnActive : "unset"};
    }
`;

export const Option = styled.div<IStyleProps>`
    ${CommonCss}
    line-height: 22px;
    ${p =>
        p.selected
            ? css`
                  font-weight: 600;
              `
            : undefined}
    &:hover {
        background-color: ${p => p.theme.c.active};
        color: ${p => p.theme.c.snowOnActive};
    }
`;

export const Wrapper = styled.div`
    position: relative;
`;

export const Options = styled.div`
    position: absolute;
    top: calc(100% + 4px);
    overflow: hidden;
    background-color: ${p => p.theme.c.cardBackground};
    width: 100%;
    z-index: 2;
    border: solid 1px ${p => p.theme.mode === "dark" ? p.theme.c.grey7 : p.theme.c.disabled};
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 0 4px 0 ${p => p.theme.c.blackShadow2};

    .OptionsScroll {
        overflow-x: hidden;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 12px;
            height: 8px;
            background-color: ${p => p.theme.c.light}; /* or add it to the track */
        }
        
        &::-webkit-scrollbar-thumb {
            cursor: pointer;
            background: ${p => p.theme.c.disabled};
            background-color: ${p => lighten(0.1, p.theme.c.pale)};
        }
        max-height: ${40 * 6}px;
    }

    &.Flipped {
        top: auto;
        bottom: calc(100% + 2px);
        box-shadow: 1px -2px 4px 0 ${p => p.theme.c.blackShadow3};
    }
`;

// export const StyledTypeahead = styled.input`
//     background-color: ${p => p.theme.c.white};
//     width: 100%;
//     border: ${p => p.theme.c.disabled} 1px solid;
//     text-overflow: ellipsis;
//     overflow: hidden;
//     white-space: nowrap;
//     ${CommonCss}
// `
